import { css } from '@emotion/react'

import Radio, { RadioItem } from '../Radio/Radio'
import { pageSubtitleCss } from '../../../../lib/styles/typography'
import { fieldsetCss, srOnlyCss } from '../../../../lib/styles/cssStyles'

const radioGroupFieldsetCss = css`
  ${fieldsetCss};
  padding: 9px 0px;
`

export type RadioGroupProps = {
  /** A11y label for the group */
  ariaLabel?: string
  /** Callback whenever the radio selection changes */
  onChange: (value: string) => void
  /** Options to be rendered as Radios within this group */
  options: Array<RadioItem>
  /** Value of the selected option */
  selectedOption: string
  /** Title for the RadioGroup */
  title?: string
}

const RadioGroup = ({ ariaLabel, onChange, options, selectedOption, title }: RadioGroupProps) => {
  const legendText = title || ariaLabel
  const showVisibleTitle = Boolean(title)

  return (
    <fieldset css={radioGroupFieldsetCss} aria-label={ariaLabel || title}>
      <legend css={showVisibleTitle ? pageSubtitleCss : srOnlyCss}>{legendText}</legend>
      {options.map((o: RadioItem) => (
        <Radio
          description={o.description}
          groupName={legendText}
          key={o.value}
          label={o.label}
          onSelect={() => onChange(o.value)}
          isSelected={selectedOption === o.value}
          value={o.value}
        />
      ))}
    </fieldset>
  )
}

export default RadioGroup
